module.exports = __webpack_public_path__ + "static/media/welcome-back-james.6ca2256c.png";